/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsListCollections = {
    init: function ($section) {
      const $collections = $section.find('[data-slider]');

      $collections.flickity({
        wrapAround: false,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'left',
        groupCells: '100%',
        // contain:true,
      });

      // Resize flickity when the slider is settled
      $collections.on('settle.flickity', function () {
        $collections.flickity('resize');
      });
      $collections.on( 'scroll.flickity', function( event, progress ) {
        $progressBar = $section.find(".slider_progrssbar");
        progress = Math.max( 0, Math.min( 1, progress ) );
        $progressBar.width( progress * 100 + '%' );
      });

    },
    blockSelect: function ($section, blockId) {
      const $collections = $section.find('[data-slider]');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $collections.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.testimonial__nav--prev').off();
      $('.testimonial__nav--next').off();
    }
  }

  /******/
})()
  ;